module.exports = __webpack_public_path__ + "img/m3.8c282dad.jpg";